module.exports = __webpack_public_path__ + "img/digital-experience-2.b9eb565e.png";